/**
 * @file Entry file for PickupForm Component
 * @author Unknown
 */

import PickupForm from "./pickup-form.container";

export default PickupForm;
